/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _config = require('../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//首次渲染时获取数据
var defaultlState = _immutable2.default.fromJS({ data: {}, isFetching: false });
var fetchData = function fetchData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultlState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _config.REQUEST_POSTS:
            return state.set('isFetching', true);
        case _config.RECEIVE_POSTS:
            return _immutable2.default.Map({ 'data': action.res, 'isFetching': false }); //返回一个新的state
        default:
            return state;
    }
};

exports.default = fetchData;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "post.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/post.jsx
// module id = 316
// module chunks = 0